import { createFileRoute } from "@tanstack/react-router";

import { ConsoleEmbeddedIdentityPage, consoleContextQueryOptions } from "@/features/console";

/** Personal Engine accounts live beside the connector catalog, not in app administration. */
export const Route = createFileRoute("/_authed/_modal/console/accounts")({
  validateSearch: (search: Record<string, unknown>) => ({
    capability: search.capability === "email" || search.capability === "drive" || search.capability === "chat" || search.capability === "calendar" ? search.capability : undefined,
    account_id: typeof search.account_id === "string" ? search.account_id : undefined,
    ando_status: typeof search.ando_status === "string" ? search.ando_status : undefined,
    ando_session: typeof search.ando_session === "string" ? search.ando_session : undefined,
    ando_proof: typeof search.ando_proof === "string" ? search.ando_proof : undefined,
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(consoleContextQueryOptions()),
  component: () => <ConsoleEmbeddedIdentityPage view="accounts" />,
});
